import policiesAPI from './policies';
import profilesAPI from './profiles';

const policiesService = {
  ...policiesAPI,
  ...profilesAPI,
};

export default policiesService;
